import * as React from 'react'

import { Box, type Colors, Text } from '@factorialco/deprecated-design-system'

import type { SupplementType } from 'modules/payroll_bundle/components/common/helper/worksheet'

const SupplementTypeLabel = ({
  supplementType,
  color,
}: {
  supplementType: SupplementType
  color?: Colors
}) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s4">
      <Box maxWidth="s120">
        <Text.Normal size="200" weight="medium" color={color} ellipsis>
          {supplementType.label}
        </Text.Normal>
      </Box>
      {supplementType.mappingsCount > 1 && (
        <Box>
          <Text.Normal size="200" weight="medium" color={color}>
            +{supplementType.mappingsCount - 1}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default SupplementTypeLabel
